export const ENDPOINTS = {
  ROOT: "https://api.acciojob.com",
  // ROOT: 'https://acciojob-backend-staging-eobnd7jx2q-el.a.run.app',
};
